import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import findElementUtils from 'utils/findElementUtils';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';
import styleUtils from 'utils/styleUtils';

function getSelectionPathToNearestBlock(editor) {
    var sel = selectionUtils.getSelectedRange(editor);
    return _.filter(sel.startPath().elements, function (element) {
        var nodeName = element.$.nodeName.toLowerCase();
        return !_.includes(['body', 'ul', 'ol', 'li'], nodeName);
    });
}

function applyStylesOnList(evtData) {
    var editor = evtData.editor;
    var createdListElement = evtData.data[0];
    if (createdListElement && !editor.editable().contains(createdListElement)) {
        createdListElement = _.find(selectionUtils.getSelectedRange(editor).startPath().elements, e => CKEDITOR.dtd.$list[_.invoke(e, 'getName')]);
    }
    var selectionPath = getSelectionPathToNearestBlock(editor);
    if (selectionPath && createdListElement) {
        _.forEach(selectionPath, function (element) {
            elementUtils.cloneStylesToElement(element, createdListElement, function filterStyles(styleName) {
                return !_.includes(['background-color', 'text-shadow', 'margin-left', 'margin-right', 'text-decoration', 'text-decoration-line', 'text-decoration-color', 'text-decoration-style'], styleName);
            });

            elementUtils.cloneClassesToElement(element, createdListElement, function filterClasses(className) {
                //todo write test that checks class wixguard was not copied, write test for SE-13684
                return !_.startsWith(className, 'backcolor_') && !_.startsWith(className, 'wixGuard');
            });
        });
        selectionUtils.getSelectedBlocks(editor, true).forEach(blockElem => blockElem.removeAttribute('dir'));
        const firstTextBlock = findElementUtils.findFirstTextBlock(editor, createdListElement);

        if (firstTextBlock) {
            handleAfterCommandForTextAlign(editor, 'justify' + firstTextBlock.getStyle('text-align'));
        }
        selectionUtils.getSelectedListItems(editor).forEach(listItem => {
            copyStyleFromFirstTextToElement(editor, listItem, 'line-height');
        });
    } else if (!selectionPath) {
        console.error('Failed to create styled list'); //eslint-disable-line no-console
    }
}

function findStyleInPath(textNode, root, styleName) {
    if (textNode && root && styleName) {
        const path = new CKEDITOR.dom.elementPath(textNode, root);
        return _.chain(path.elements)
            .reject(element => root.equals(element))
            .filter(element => element.$.style[styleName])
            .first()
            .get('$.style[' + styleName + ']')
            .value() || CKEDITOR.TRISTATE_OFF;
    }
    return CKEDITOR.TRISTATE_OFF;
}

const shouldHandleCommandAfterExecForStyle = evt => _.includes(['italic', 'bold', 'unItalic', 'unBold'], _.get(evt, 'data.name'));

const shouldHandleCommandAfterExecForTextAlign = evt => _.includes(['justifyleft', 'justifycenter', 'justifyright', 'justifyblock'], _.get(evt, 'data.name'));

const shouldHandleCommandAfterExecForDirection = evt => _.includes(['bidiltr', 'bidirtl'], _.get(evt, 'data.name'));

const shouldHandleCommandAfterExecForLineHeight = evt => _.includes(['lineHeight'], _.get(evt, 'data.name'));

const getStyleName = evt => _.keys(_.get(evt, 'data.command.style._.definition.styles'))[0];

function copyStyleFromFirstTextToElement(editor, listElem, styleName) {
    const textNode = findElementUtils.findFirstNonEmptyTextNode(editor, listElem);
    const style = findStyleInPath(textNode, listElem, styleName);
    styleUtils.applyStyle(style, styleName, listElem);
}

function handleAfterCommandForDirection(editor) {
    const dirAttribute = editor.getCommand('bidirtl').state === CKEDITOR.TRISTATE_ON ? 'rtl' : 'ltr';
    selectionUtils.getSelectedLists(editor, true).forEach(listElem => {
        const range = new CKEDITOR.dom.range(editor.editable());
        range.selectNodeContents(listElem);
        range.shrink();
        rangeUtils.getBlocks(range, true).forEach(blockElem => {
            blockElem.removeAttribute('dir');
        });
        if (window.getComputedStyle(listElem.$).direction !== dirAttribute) {
            listElem.setAttribute('dir', dirAttribute);
        } else {
            listElem.removeAttribute('dir');
        }
    });
}

function removeTextAlignFromChildren(editor, listElem) {
    const range = new CKEDITOR.dom.range(editor.editable());
    range.selectNodeContents(listElem);
    range.shrink();
    rangeUtils.getBlocks(range, true).forEach(blockElem => {
        blockElem.removeStyle('text-align');
    });
}

function handleAfterCommandForTextAlign(editor, cmdName) {
    const selectedLists = selectionUtils.getSelectedLists(editor, true);
    if (selectedLists.length) {
        selectedLists.forEach(listElem => {
            const style = cmdName.replace('justify', '').replace('block', 'justify');
            removeTextAlignFromChildren(editor, listElem);
            listElem[style === 'center' ? 'addClass' : 'removeClass']('wix-list-text-align');
            listElem.setStyle('text-align', style);
        });
        const path = selectionUtils.getSelectedRange(editor).startPath();
        _.forEach(['justifyleft', 'justifycenter', 'justifyright', 'justifyblock'], _cmdName => {
            editor.getCommand(_cmdName).refresh(editor, path);
        });
    }
}

function handleAfterCommandForLineHeight(editor) {
    selectionUtils.getSelectedListItems(editor).forEach(listItem => {
        copyStyleFromFirstTextToElement(editor, listItem, 'line-height');
    });
}

function handleAfterCommandExec(editor, evt) {
    const styleName = getStyleName(evt);
    if (shouldHandleCommandAfterExecForStyle(evt) && styleName) {
        selectionUtils.getSelectedLists(editor).forEach(listElem => copyStyleFromFirstTextToElement(editor, listElem, styleName));
    } else if (shouldHandleCommandAfterExecForTextAlign(evt)) {
        handleAfterCommandForTextAlign(editor, _.get(evt, 'data.name'));
    } else if (shouldHandleCommandAfterExecForDirection(evt)) {
        handleAfterCommandForDirection(editor);
    } else if (shouldHandleCommandAfterExecForLineHeight(evt)) {
        handleAfterCommandForLineHeight(editor);
    }
}

export default {
    init: function (editor) {
        var cmdNumbered = editor.getCommand('numberedlist');
        var cmdBullets = editor.getCommand('bulletedlist');
        cmdNumbered.on('listChange', applyStylesOnList);
        cmdBullets.on('listChange', applyStylesOnList);
        editor.on('afterCommandExec', (...args) => handleAfterCommandExec(editor, ...args));
    }
};
